var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-card"},[_c('header',{staticClass:"header"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("header")],2),_c('main',{staticClass:"body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }